//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams,toCopy} from '@/utils/util.js'
import homeTip from '@/components/homeTip'

export default {
  name: "qualityOrderDetailAll",
  components: {
    homeTip
  },
  data() {
    return {
      toCopy,
      reasonShow:false,
      popReason:'',
      reasonList:[
        {reason:'面料疵点',number:5,type:'一般'},
        {reason:'面料疵点',number:5,type:'一般'},
        {reason:'面料疵点',number:5,type:'一般'},
        {reason:'面料疵点',number:5,type:'一般'},
      ],
      basicForm: {
        qualityOrderSn: '',
        sendOrderSn: '',
        purchaseOrderSn: '',
        supplierName: '',
        channelStr: '',
        qualityOrderTypeName: '',
        qualityOrderDetailList: [],
        qualityOrderResultDetailList: [],
        attachedFile: [],
        isStockIn:'',
        confirmFileStr:'',
        confirmFile:'',
        remark:'',
        qualityResult:'',
        qualityOrderStatusName:'',
        billDate:'',
        externalOrder:'',
        needAduit:'',
        spuCode:'',
        sendTotalGoodsNum:'',
        crtTime:'',
        percent:'',
        rejectNum:''
      },
      dataList:{},
      qualityOrderId:'',
      qualityResultId:'',
    }
  },
  created() {
  },
  mounted() {
    if (this.$route.query.data) {
      this.dataList = JSON.parse(this.$route.query.data)
    }
    if (this.$route.query.qualityOrderId) {
      this.qualityOrderId = this.$route.query.qualityOrderId
      this.qualityResultId = this.$route.query.qualityResultId
    }
    this.getSpecList()
  },
  methods: {
    getSpecList() {
      var queryParams = {
        qualityOrderColorList:[this.dataList]
      };
      if (this.$route.query.data) {
        queryParams.qualityOrderColorList = [this.dataList]
      }else{
        queryParams.qualityOrderId = this.qualityOrderId
        queryParams.qualityResultId = this.qualityResultId
        queryParams.qualityOrderColorList = []
      }
      axiosApi.queryOrderQualityResultReason({}).then(res=>{
        var list = res.content
      axiosApi.queryQualityOrderByColor(queryParams).then(response => {
        var data = response.content;
        if(data.qualityOrderDetailList){
          data.qualityOrderDetailList.forEach((item)=>{item.isEdit = true})
        }
        for (var ind in data) {
          var val = data[ind] != null ? data[ind] : ""
          this.$set(this.basicForm, ind, val)
        }
        var channelStr = '';
        if(this.basicForm.firstDeptName){
          channelStr+=this.basicForm.firstDeptName
        }
        if(this.basicForm.secondDeptName){
          channelStr+='/'+this.basicForm.secondDeptName
        }
        var List = []
          for (let i = 0; i < data.qualityOrderResultDetailList.length; i++) {
            list.forEach(item => {
              if(item.id == data.qualityOrderResultDetailList[i].reasonId[0]){
                this.basicForm.qualityOrderResultDetailList[i].reason = item.name
              }
              });
            }
        if(this.basicForm.qualityOrderResultDetailList&&this.basicForm.qualityOrderResultDetailList.length>0){
          this.basicForm.qualityOrderResultDetailList.forEach((item)=>{
            item.remarkStr = item.remark
            item.typeStr = item.noPassType ==1?'严重':'一般'
          })

        }
        this.$set(this.basicForm, 'channelStr', channelStr)
        // this.$refs.commonTableRef2.reloadDone()
      }).catch(error => {
        // this.$refs.commonTableRef2.reloadDone()
      })
             })
    },
    showDetail(remark){
      this.popReason = remark
      this.reasonShow = true
    },
    toMore(){
      this.$router.push({name:'qualityOrderDetailMore'})
    },
    toBase(){
      this.$router.push({name:'qualityOrderDetailBase'})
    },
    toAddReason(){
      this.$router.push({name:'addReason',type:2})
    },
    getPercent(row){
      var total = 0
      if(row.num){
        this.basicForm.qualityOrderResultDetailList.forEach((item)=>{
          if(item.num){
            total+=item.num
          }
        })
        return (parseInt(row.num) / parseInt(total) * 100).toFixed(2)
      }else{
        return 0
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/qualityOrder/detailAll.vue